import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Beneficjent } from '../../models/beneficjent';
import { HttpErrorDetails } from '../../../core/services/http-error-response.service';
import { ApplicationContext } from '../../../core/services/application-context.service';
import { ApplicationContextDto } from '../../models/wybrana-organizacja';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/auth';

  public signInByLogin$(
    username: string,
    password: string,
  ): Observable<HttpResponse<Beneficjent>> {
    return this.#httpClient.post<Beneficjent>(
      `${this.#apiUrl}/signIn`,
      {
        username,
        password,
      },
      {
        withCredentials: true,
        observe: 'response',
      },
    );
  }

  public signInBySignature$(
    signature: string,
  ): Observable<HttpResponse<Beneficjent>> {
    return this.#httpClient.post<Beneficjent>(
      `${this.#apiUrl}/signInSignature`,
      signature,
      {
        headers: {
          'Content-Type': 'text/plain',
        },
        observe: 'response',
        withCredentials: true,
      },
    );
  }

  public logOut$(): Observable<void> {
    return this.#httpClient.post<void>(`${this.#apiUrl}/logOut`, undefined, {
      withCredentials: true,
    });
  }

  public changeApplicationContext$(
    applicationContext: ApplicationContext,
    idOrganizacji?: number,
  ): Observable<ApplicationContextDto> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('applicationContext', applicationContext);

    if (idOrganizacji) {
      httpParams = httpParams.set('idOrganizacji', idOrganizacji);
    }
    return this.#httpClient.post<ApplicationContextDto>(
      `${this.#apiUrl}/changeApplicationContext`,
      undefined,
      {
        withCredentials: true,
        params: httpParams,
      },
    );
  }

  public podpis$(): Observable<void> {
    let httpParams = new HttpParams();
    return this.#httpClient.get<void>(
      `http://localhost:8080/api/saml2/authenticate/logingovpl`,
      {
        withCredentials: true,
        params: httpParams,
      },
    );
  }

  public refreshSession$(): Observable<void> {
    return this.#httpClient.get<void>(`${this.#apiUrl}/refreshSession`, {
      withCredentials: true,
    });
  }

  public getCurrentUser$(): Observable<HttpResponse<Beneficjent>> {
    return this.#httpClient.get<Beneficjent>(`${this.#apiUrl}/user`, {
      withCredentials: true,
      observe: 'response',
    });
  }

  public getCurrentUserByPreAuthCookie$(): Observable<Beneficjent> {
    return this.#httpClient.get<Beneficjent>(`${this.#apiUrl}/user/preAuth`, {
      withCredentials: true,
    });
  }

  public getWkError$(errorId: string): Observable<HttpErrorDetails> {
    let httpParams = new HttpParams().set('errorId', errorId);
    return this.#httpClient.get<HttpErrorDetails>(
      `${this.#apiUrl}/getWkError`,
      { params: httpParams },
    );
  }

  public updateLastLoginDate$(): Observable<boolean> {
    return this.#httpClient.post<boolean>(
      `${this.#apiUrl}/updateLastLoginDate`,
      undefined,
      {
        withCredentials: true,
      },
    );
  }

  public acceptTermsAndConditions$(): Observable<boolean> {
    return this.#httpClient.post<boolean>(
      `${this.#apiUrl}/acceptTermsAndConditions`,
      undefined,
      {
        withCredentials: true,
      },
    );
  }
}
